import { toHumanFriendlyFormat } from '@/util/date'
import moment from 'moment'
// 通常（このコンポーネントへの入力や出力）で利用する日付フォーマット
const DATE_FORMAT = 'YYYYMMDD'

export default {
  /**
   * 期間条件標準フォーマット
   *
   * 日 / 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週や月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（日:d / 週:w / 月:m）
       */
      termType: 'w',
      /**
       * 当期間
       */
      base: {
        /**
         * 開始日
         */
        dateFrom: undefined,
        /**
         * 終了日
         */
        dateTo: undefined,
        /**
         * ～から、～まで
         */
        // weekType: 'COUNT_TO',
      },
      /**
       * 当期間
       */
      compare: {
        /**
         * 開始日
         */
        dateFrom: undefined,
        /**
         * 終了日
         */
        dateTo: undefined,
        /**
         * ～から、～まで
         */
        // weekType: 'COUNT_TO',
      },
      /**
       * 入力エラー
       */
      errors: [],
      /**
       * ～から、～まで
       */
      weekType: 'COUNT_FROM',
      /**
       * 月初日表示、月末日表示
       */
      displayClosingMonth: 'DISPLAY_TO',
      /**
       * 締め日（月度選択時）
       */
      closingDay: 20,
      /**
       * 期間比較を行う場合
       */
      isCompareEnabled: true,
      /**
       * 比較の際の単位数（日⇒N日前のNに該当）
       */
      termOffset: 5,
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    return {
      // TODO API側で特に不要なので期間種別は除外していましたが、
      //      分析条件をサーバーから取得して復元する & 期間種別も
      //      復元したい場合、送らざるを得ない。
      base: {
        termType: term.termType,
        dateFrom: term.base.dateFrom,
        dateTo: term.base.dateTo,
      },
      compare: {
        termType: term.termType,
        dateFrom: term.compare.dateFrom,
        dateTo: term.compare.dateTo,
      },
      displayClosingMonth: term.displayClosingMonth,
      weekType: term.weekType,
      closingDay: term.closingDay,
      compareEnabled: term.isCompareEnabled,
      termOffset: term.termOffset,
    }
  },
  /**
   * applyToに対してtermを適用する
   * 導入前に保存された条件にはweekTypeがなく、
   * 復元時にはundefinedなのでweekTypeにはデフォルトCOUNT_FROMを入れる
   */
  applyPayload(applyTo, term) {
    // term.baseが無い場合に対応（異なるコンポーネントから切り替えた場合など）
    if (term.base) {
      // POSでもMousePos(Duck)でも現状の分析から復元ができるように両方見る
      applyTo.termType = term.termType || term.base.termType || 'w'
      applyTo.base.dateFrom =
        term.base.dateFrom ||
        moment()
          .subtract(1, 'weeks')
          .format(DATE_FORMAT)
      applyTo.base.dateTo = term.base.dateTo || moment().format(DATE_FORMAT)
      applyTo.base.weekType = term.base.weekType || 'COUNT_FROM'
      if (term.compare) {
        applyTo.compare.dateFrom =
          term.compare.dateFrom ||
          moment()
            .subtract(2, 'weeks')
            .format(DATE_FORMAT)
        applyTo.compare.dateTo =
          term.compare.dateTo ||
          moment()
            .subtract(1, 'weeks')
            .format(DATE_FORMAT)
        applyTo.compare.weekType = term.compare.weekType || 'COUNT_FROM'
      } else {
        applyTo.compare.dateFrom = moment()
          .subtract(2, 'weeks')
          .format(DATE_FORMAT)
        applyTo.compare.dateTo = moment()
          .subtract(1, 'weeks')
          .format(DATE_FORMAT)
        applyTo.compare.weekType = 'COUNT_FROM'
      }
      applyTo.isCompareEnabled = term.isCompareEnabled || false
      applyTo.weekType = term.weekType || 'COUNT_FROM'
      applyTo.termOffset = term.termOffset || 1
      applyTo.closingDay =
        term.closingDay || moment(term.base.dateTo).date() || 20
      applyTo.displayClosingMonth =
        term.displayClosingMonth ||
        term.base.displayClosingMonth ||
        'DISPLAY_TO'
    } else {
      applyTo.termType = term.termType || 'w'
      applyTo.base.dateFrom =
        term.dateFrom ||
        moment()
          .subtract(1, 'weeks')
          .format(DATE_FORMAT)
      applyTo.base.dateTo = term.dateTo || moment().format(DATE_FORMAT)
      applyTo.base.weekType = 'COUNT_FROM'
      applyTo.compare.dateFrom =
        term.dateFrom ||
        moment()
          .subtract(2, 'weeks')
          .format(DATE_FORMAT)
      applyTo.compare.dateTo =
        term.dateTo ||
        moment()
          .subtract(1, 'weeks')
          .format(DATE_FORMAT)
      applyTo.compare.weekType = 'COUNT_FROM'
      applyTo.isCompareEnabled = false
      applyTo.weekType = 'COUNT_FROM'
      applyTo.termOffset = 1
      applyTo.closingDay = term.closingDay || moment(term.dateTo).date() || 20
      applyTo.displayClosingMonth = term.displayClosingMonth || 'DISPLAY_TO'
    }
  },
  summaryText(term) {
    if (term.base) {
      return (
        toHumanFriendlyFormat(term.base.dateFrom) +
        ' ～ ' +
        toHumanFriendlyFormat(term.base.dateTo)
      )
    } else {
      return (
        toHumanFriendlyFormat(term.dateFrom) +
        ' ～ ' +
        toHumanFriendlyFormat(term.dateTo)
      )
    }
  },
  getOverride(transitionData, destination, queryFilter) {
    const baseDateFrom = transitionData.base.dateFrom
    const baseDateTo = transitionData.base.dateTo
    const compareDateFrom = transitionData.compare.dateFrom
    const compareDateTo = transitionData.compare.dateTo
    return {
      immediate: true,
      term: {
        termType:
          destination === 'chocostick-t' ? 'd' : queryFilter.term.termType,
        base: {
          ...transitionData.base,
          dateFrom: baseDateFrom.replaceAll('-', ''),
          dateTo: baseDateTo.replaceAll('-', ''),
        },
        compare: {
          ...transitionData.compare,
          dateFrom: compareDateFrom
            ? compareDateFrom.replaceAll('-', '')
            : baseDateFrom.replaceAll('-', ''),
          dateTo: compareDateTo
            ? compareDateTo.replaceAll('-', '')
            : baseDateTo.replaceAll('-', ''),
          isCompareEnabled: queryFilter.term.isCompareEnabled,
          displayClosingMonth: queryFilter.term.displayClosingMonth,
          termOffset: queryFilter.term.termOffset,
        },
      },
    }
  },
}
